import AppDataService from "./AppDataService";

export default class FacilityManagementService {
  static async getFacilityList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`facility${queryString}`);
  }

  static async getFacilityById(id) {
    return await AppDataService.get(`facility/${id}`);
  }

  static async postFacilityData(data) {
    return await AppDataService.post(`facility`, data);
  }

  static async patchFacilityData(facilityId, data) {
    return await AppDataService.patch(`facility/${facilityId}`, data);
  }

  static async addDepartment(data) {
    return await AppDataService.post(`department`, data);
  }

  static async getDepartmentList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      // data?.status ? `status=${data?.status}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`department${queryString}`);
  }

  static async patchDepartmentData(departmentId, data) {
    return await AppDataService.patch(`department/${departmentId}`, data);
  }

  static async deleteDepartment(departmentId, force = false) {
    const queryParams = force ? `?force=true` : `?force=false`;
    return await AppDataService.delete(`department/${departmentId}${queryParams}`);
  }

  static async addRoom(data) {
    return await AppDataService.post(`room`, data);
  }

  static async getRoomList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`room${queryString}`);
  }

  static async patchRoom(roomId, data) {
    return await AppDataService.patch(`room/${roomId}`, data);
  }

  static async deleteRoom(roomId) {
    return await AppDataService.delete(`room/${roomId}`);
  }

  static async getClinicLocations() {
    return await AppDataService.get(`basecamp`);
  }

  static async createBaseCamp(data) {
    return await AppDataService.post(`basecamp`, data);
  }

  static async getPatientList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `searchKey=${data.name}` : "",
      // data?.status ? `status=${data?.status}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`patient${queryString}`);
  }

  static async createNewPatient(data) {
    return await AppDataService.post(`patient`, data);
  }

  static async getInventoryListData(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
      data?.name ? `searchValue=${data?.name}` : "",
      data?.type ? `type=${data?.type}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(
      `facility/facility/inventory${queryString}`
    );
  }
  static async createFacilityInventoryData(data) {
    console.log("API Payload:", data);
    return await AppDataService.post(`facility/inventory`, data);
  }

  static async patchFacilityInventoryData(itemId, data) {
    return await AppDataService.patch(`facility/inventory/${itemId}`, data);
  }

  static async deleteFacilityInventory(id) {
    return await AppDataService.delete(`facility/inventory/${id}`);
  }

  // Adjust Inventory: create one or more notes (Waste/Damaged/etc.) for a
  // facility inventory item. `data` is an array of { type, quantity, comment }.
  static async postInventoryNotes(facilityOrderInventoryId, data) {
    return await AppDataService.post(
      `facility-order-inventory-notes/${facilityOrderInventoryId}`,
      data
    );
  }

  // Notes grouped by facility inventory id for comma-separated ids (view + bulk).
  static async getInventoryNotesGroupedByIds(ids) {
    return await AppDataService.get(
      `facility-order-inventory-notes/grouped/by-ids?ids=${ids}`
    );
  }

  // Transfer inventory to a pharmacy/facility. `data` = { target, facilityId?, items }.
  static async postBulkTransfer(data) {
    return await AppDataService.post(
      `facility-order-inventory-notes/bulk/transfer`,
      data
    );
  }

  static async getRolesList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.type ? `type=${data?.type}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`role${queryString}`);
  }

  static async addNewFacilityUser(data) {
    return await AppDataService.post(`user`, data);
  }

  static async getFacilityUserList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
      data?.type ? `type=${data?.type}` : "",
      data?.includeAdminUsers ? `includeAdminUsers=true` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`user${queryString}`);
  }

  static async patchFacilityUser(id, data) {
    console.log("----> HEREREER", id, data);
    return await AppDataService.patch(`user/${id}`, data);
  }

  static async deleteFacilityUser(id) {
    return await AppDataService.delete(`user/${id}`);
  }

  static async sendFacilityUserInvitation(id) {
    return await AppDataService.post(`user/send-invitation`, { id });
  }

  static async sendFacilityUserBulkInvitation(ids) {
    return await AppDataService.post(`user/send-invitation/bulk`, {
      ids,
      isAdmin: false,
    });
  }

  static async deleteFacility(facilityId, force = false) {
    const queryParams = force ? `?force=true` : `?force=false`;
    return await AppDataService.delete(`facility/${facilityId}${queryParams}`);
  }

  static async uploadFacilityInventoryFile(fileData) {
    return await AppDataService.post(`facility/inventory/upload`, fileData);
  }

  static async uploadUsersFile(fileData) {
    return await AppDataService.post(`user/upload/bulk`, fileData);
  }
}
